import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import xlsx from 'xlsx';
import { isCardNo } from '@/utils/validate';
import { cloneDeep } from 'lodash';
import { blacklistVerifyData, blacklistImportData } from './request';
import { blackTypeEnums } from '../utils';
export default {
  props: {
    importVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      current: 0,
      importStatus: 'BEFOREUPLOAD',
      steps: [{
        title: '上传文件'
      }, {
        title: '数据预览'
      }],
      fileList: [],
      columns: [{
        slots: {
          title: '黑名单类型'
        },
        dataIndex: 'blacklistTypeLabel',
        key: 'blacklistTypeLabel',
        align: 'center'
      }, {
        slots: {
          title: '企业名称'
        },
        dataIndex: 'companyName',
        key: 'companyName',
        align: 'center'
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNo',
        key: 'idNo',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 180,
        key: '9'
      }],
      dataInfo: [],
      fileData: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共') + total + this.$t('条')}`;
        }
      },
      editVisible: false,
      editLine: -1,
      form: {
        blacklistTypeLabel: '',
        companyName: '',
        idNo: ''
      },
      blacklistTypeData: blackTypeEnums,
      disableNextButton: false,
      policyInfo: {}
    };
  },
  computed: {
    rules() {
      return {
        blacklistTypeLabel: [{
          required: true,
          message: this.$t('请选择') + this.$t('黑名单类型'),
          trigger: 'change'
        }],
        companyName: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('名称')
        }, {
          min: 2,
          max: 15,
          message: this.$t('字符长度超过50,请修改')
        }],
        idNo: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    importVisible: {
      async handler(newVal) {
        if (!newVal) return;
        this.fileList = [];
        this.dataInfo = [];
        this.current = 0;
        this.importStatus = 'BEFOREUPLOAD';
        this.pagination = {
          showSizeChanger: true,
          showQuickJumper: true,
          total: 0,
          pageSize: 10,
          // 每页条数
          current: 1,
          showTotal: total => {
            return `${this.$t('共') + total + this.$t('条')}`;
          }
        };
      }
    }
  },
  methods: {
    validateCard(rule, idcard, callback) {
      if (!isCardNo(idcard) || idcard == '') {
        callback(new Error(this.$t('请输入18位大陆身份证号')));
      } else {
        callback();
      }
    },
    beforeUpload(file) {
      console.log(file, 'file');
      const imgReg = /(xlsx|xls)$/;
      const fileName = file.name;
      const imgSuffix = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
      const isExcel = imgReg.test(imgSuffix);
      if (!isExcel) {
        this.$message.error(this.$t('请上传正确的格式'));
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        this.$message.error(this.$t('文件大小超过1M'));
        return;
      }
      this.fileList = [];
      this.fileList = [...this.fileList, file];
      return false;
    },
    back() {
      if (this.current > 0) {
        this.current--;
      }
    },
    next() {
      if (this.fileList.length === 0) {
        this.$message.error(this.$t('请上传文件') + '!');
        return;
      }
      if (this.fileData.length > 1000) {
        this.$message.error(this.$t('导入附件内人员行数不超过1000行'));
        return;
      }
      if (this.current === 0) {
        //下一步 展示表格
        if (this.tableHeader && this.tableHeader.length > 0) {
          const header = ['黑名单类型', '企业名称', '证件号码'];
          console.log(this.tableHeader, 'this.tableHeader');
          if (this.tableHeader.length !== header.length) {
            this.$message.error(this.$t('文件格式不正确'));
            return;
          } else {
            let isPass = true;
            this.tableHeader.forEach((item, index) => {
              if (item !== header[index]) {
                isPass = false;
              }
            });
            if (!isPass) {
              this.$message.error(this.$t('文件格式不正确'));
              return;
            }
          }
        }
        if (!this.tableHeader || this.tableHeader.length === 0) {
          this.$message.error(this.$t('文件格式不正确'));
          return;
        }
        this.current++;
        this.dataInfo = [];
        this.dataInfo = cloneDeep(this.fileData).map((item, index) => {
          let obj = {
            blacklistTypeLabel: item['黑名单类型'] || '-',
            companyName: item['企业名称'] || '-',
            idNo: item['证件号码'] ? item['证件号码'] + '' : '-'
          };
          obj.errorMessage = this.checkData(obj); //校验错误数据
          return obj;
        });
      } else {
        //开始校验  校验完成导入
        let hasErr = false;
        for (let i = 0; i < this.dataInfo.length; i++) {
          var _this$dataInfo$i;
          if (((_this$dataInfo$i = this.dataInfo[i]) === null || _this$dataInfo$i === void 0 || (_this$dataInfo$i = _this$dataInfo$i.errorMessage) === null || _this$dataInfo$i === void 0 ? void 0 : _this$dataInfo$i.length) > 0) {
            hasErr = true;
            let recentErrorPage = parseInt(i / this.pagination.pageSize) + 1;
            this.pagination.current = recentErrorPage;
            break;
          }
        }
        if (!hasErr) {
          let data = cloneDeep(this.dataInfo);
          data.map(item => {
            let findblacklistType = this.blacklistTypeData.filter(i => {
              var _i$label, _item$blacklistTypeLa;
              return ((_i$label = i.label) === null || _i$label === void 0 ? void 0 : _i$label.replace(/\s/g, '')) === ((_item$blacklistTypeLa = item.blacklistTypeLabel) === null || _item$blacklistTypeLa === void 0 ? void 0 : _item$blacklistTypeLa.replace(/\s/g, ''));
            });
            if (findblacklistType.length > 0) {
              item.blacklistType = findblacklistType[0].value;
            }
            return item;
          });
          let params = {
            blacklistData: data
          };
          console.log(params, 'params');
          //导入前校验
          this.disableNextButton = true;
          blacklistVerifyData(params).then(res => {
            this.disableNextButton = false;
            if (res.status === 'FAIL') {
              this.$message.error(this.$t('数据校验未通过'));
              this.dataInfo = [...res.data];
            } else {
              this.importPersonnel();
            }
          }).catch(() => {
            this.disableNextButton = false;
          });
        } else {
          this.$message.error(this.$t('请修改完错误项后继续【下一步】'));
        }
      }
    },
    importPersonnel() {
      this.importStatus = 'UPLOAD';
      let data = cloneDeep(this.dataInfo);
      data.map((item, index) => {
        let findblacklistType = this.blacklistTypeData.filter(i => {
          var _i$label2, _item$blacklistTypeLa2;
          return ((_i$label2 = i.label) === null || _i$label2 === void 0 ? void 0 : _i$label2.replace(/\s/g, '')) === ((_item$blacklistTypeLa2 = item.blacklistTypeLabel) === null || _item$blacklistTypeLa2 === void 0 ? void 0 : _item$blacklistTypeLa2.replace(/\s/g, ''));
        });
        if (findblacklistType.length > 0) {
          item.blacklistType = findblacklistType[0].value;
        }
        delete item.errorMessage;
        return item;
      });
      let obj = {
        blacklistData: data
      };
      console.log(obj, 'obj');
      blacklistImportData(obj).then(res => {
        this.importStatus = 'UPLOADCOMPLATE';
        this.current++;
      }).catch(e => {
        this.importStatus = 'UPLOADERROR';
      });
    },
    checkData(item) {
      //校验数据是否有误
      let errorMessage = [];
      let findblacklistType = this.blacklistTypeData.filter(i => {
        var _i$label3, _item$blacklistTypeLa3;
        return ((_i$label3 = i.label) === null || _i$label3 === void 0 ? void 0 : _i$label3.replace(/\s/g, '')) === ((_item$blacklistTypeLa3 = item.blacklistTypeLabel) === null || _item$blacklistTypeLa3 === void 0 ? void 0 : _item$blacklistTypeLa3.replace(/\s/g, ''));
      });
      if (findblacklistType.length === 0) {
        errorMessage.push('黑名单类型错误');
      }
      let blackType = findblacklistType.length > 0 ? findblacklistType[0].value : '';
      if (blackType === 'company' && item.companyName.length > 50) {
        errorMessage.push('企业名称超过50字符');
      }
      console.log(item.idNo, isCardNo(item.idNo), 'item.idNo');
      if (blackType === 'person' && !isCardNo(item.idNo)) {
        errorMessage.push('身份证号有误');
      }
      return errorMessage;
    },
    remove() {
      this.tableHeader = [];
      this.fileList = [];
    },
    handleStandardTableChange(val) {
      this.pagination = val;
    },
    getClassName(item) {
      var _item$errorMessage;
      return ((_item$errorMessage = item.errorMessage) === null || _item$errorMessage === void 0 ? void 0 : _item$errorMessage.length) > 0 ? 'red-row-class' : '';
    },
    handleChange(info) {
      var _info$fileList;
      if (!info.file) {
        this.dataInfo = [];
        return;
      }
      this.tableHeader = [];
      const fileReader = new FileReader();
      fileReader.onload = e => {
        let binaryData = e.target.result;
        let workbook = xlsx.read(binaryData, {
          type: 'buffer',
          cellDates: true
        });
        const wsname = workbook.SheetNames[0]; //取第一张表
        let ref = workbook.Sheets[wsname]['!ref'];
        this.tableHeader = this.getHeaderRow(workbook.Sheets[wsname]);
        this.fileData = xlsx.utils.sheet_to_json(workbook.Sheets[wsname], {
          range: ref
        }); //生成json表格内容
      };
      if ((_info$fileList = info.fileList) !== null && _info$fileList !== void 0 && _info$fileList.length) {
        fileReader.readAsArrayBuffer(info.fileList[0].originFileObj);
      }
    },
    editRecord(record, index) {
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.dataInfo.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
      this.editLine = index;
      this.editVisible = true;
      this.$refs.dataFrom && this.$refs.dataFrom.resetFields();
      this.form.companyName = record['companyName'];
      this.form.blacklistTypeLabel = record['blacklistTypeLabel'];
      this.form.idNo = record['idNo'];
    },
    getHeaderRow(sheet) {
      const headers = []; // 定义数组，用于存放解析好的数据
      let ref = sheet['!ref'];
      const range = xlsx.utils.decode_range(ref); // 读取sheet的单元格数据
      let C;
      const R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[xlsx.utils.encode_cell({
          c: C,
          r: R
        })];
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = xlsx.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers; // 经过上方一波操作遍历，得到最终的第一行头数据
    },
    deleteRecord(index) {
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.dataInfo.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
      let deleteIndex = (this.pagination.current - 1) * this.pagination.pageSize + index;
      this.dataInfo.splice(deleteIndex, 1);
    },
    handleCancel() {
      this.$emit('refreshList');
      this.$emit('update:importVisible', false);
    },
    editCancel() {
      this.editVisible = false;
    },
    handleOk() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          if (this.blacklistTypeData.length > 0) {
            let findblacklistType = this.blacklistTypeData.filter(i => {
              var _i$label4, _this$form$blacklistT;
              return ((_i$label4 = i.label) === null || _i$label4 === void 0 ? void 0 : _i$label4.replace(/\s/g, '')) === ((_this$form$blacklistT = this.form.blacklistTypeLabel) === null || _this$form$blacklistT === void 0 ? void 0 : _this$form$blacklistT.replace(/\s/g, ''));
            });
            if (findblacklistType.length === 0) {
              this.$message.error(this.$t('黑名单类型输入与此单元格数据不匹配'));
              return;
            }
          }
          this.editVisible = false;
          let editIndex = (this.pagination.current - 1) * this.pagination.pageSize + this.editLine;
          this.dataInfo[editIndex] = {
            companyName: this.form['companyName'],
            blacklistTypeLabel: this.form['blacklistTypeLabel'],
            idNo: this.form['idNo']
          };
        }
      });
    },
    download() {
      //下载模板
      let url = 'https://insurforce.oss-cn-beijing.aliyuncs.com/%E9%BB%91%E5%90%8D%E5%8D%95%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx';
      let filecompanyName = this.$t('批量导入人员模板') + '.xlsx';
      const link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('download', filecompanyName);
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 下载完成移除元素
      window.URL.revokeObjectURL(url); // 释放掉blob对象
    }
  }
};